import { CommonService } from "../common.service";
var LeaderTalkComponent = (function () {
    function LeaderTalkComponent(commonService) {
        this.commonService = commonService;
        this.isHarmonyOS = false; //是否鸿蒙系统
    }
    LeaderTalkComponent.prototype.ngOnInit = function () {
        this.isHarmonyOS = this.commonService.isHarmonyOS();
    };
    LeaderTalkComponent.prototype.ngAfterViewInit = function () {
        var htmlFontSize = document.documentElement.clientWidth / 7.5;
        document.documentElement.style.fontSize = htmlFontSize + "px";
        if (this.headImageUrl) {
            $("#leader_talk_wrap #picture").css("background-image", "url(" + this.headImageUrl + ")");
        }
        if (this.talk.length > 13) {
            $(".talk_item").last().width($("#test").width());
        }
    };
    return LeaderTalkComponent;
}());
export { LeaderTalkComponent };



// WEBPACK FOOTER //
// ./src/app/leader-talk/leader-talk.component.ts.pre-build-optimizer.js